import React, { useContext } from 'react'
import { TemplateContext } from '~/components/Template/context'
import { Circle } from './styles'
import { Tag } from '@provi/provi-components'

export const Tags = ({ value, color, textColor }) => {
  const { isMobile } = useContext(TemplateContext)
  return <>{isMobile ? <Circle color={color} /> : <Tag text={value} color={color} textColor={textColor} />}</>
}
